import { BRAND_CONFIG_MAPPING } from 'utils/brand-config';
import { BrandCodeType } from 'utils/globalTypes';

// eslint-disable-next-line import/prefer-default-export
export function getBrandVaultProject(brandCode: BrandCodeType) {
  return (
    BRAND_CONFIG_MAPPING[brandCode]?.vaultProject ??
    BRAND_CONFIG_MAPPING.privacy.vaultProject
  );
}
